import { StyleSheet } from 'aphrodite';
import { type ComponentProps, memo } from 'react';
import { StreamdownLite } from '../StreamdownLite';

type ResponseProps = ComponentProps<typeof StreamdownLite>;

export const AIMarkdownResponse = memo(
	({ styles = [], ...props }: ResponseProps) => <StreamdownLite styles={[s.root, ...styles]} {...props} />,
	(prevProps, nextProps) => prevProps.children === nextProps.children
);

AIMarkdownResponse.displayName = 'Response';

const s = StyleSheet.create({
	root: {
		width: '100%',
		height: '100%',
	},
	':has(*) > *:first-child': {
		marginTop: 0,
	},
	':has(*) > *:last-child': {
		marginBottom: 0,
	},
});
